/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { oktaResourceConnectionsList } from "../funcs/oktaResourceConnectionsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListOktaResourceConnectionsResult } from "../models/components/listoktaresourceconnectionsresult.js";
import {
  ListOktaResourceConnectionsRequest,
  ListOktaResourceConnectionsSecurity,
} from "../models/operations/listoktaresourceconnections.js";
import { unwrapAsync } from "../types/fp.js";
export type OktaResourceConnectionsQueryData =
  ListOktaResourceConnectionsResult;

export function prefetchOktaResourceConnections(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListOktaResourceConnectionsRequest | undefined,
  security?: ListOktaResourceConnectionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOktaResourceConnectionsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildOktaResourceConnectionsQuery(
  client$: GramCore,
  request?: ListOktaResourceConnectionsRequest | undefined,
  security?: ListOktaResourceConnectionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OktaResourceConnectionsQueryData>;
} {
  return {
    queryKey: queryKeyOktaResourceConnections({
      includeAll: request?.includeAll,
      gramSession: request?.gramSession,
    }),
    queryFn: async function oktaResourceConnectionsQueryFn(
      ctx,
    ): Promise<OktaResourceConnectionsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(oktaResourceConnectionsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyOktaResourceConnections(
  parameters: {
    includeAll?: boolean | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "oktaResourceConnections", "list", parameters];
}
